/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Heading_LabelInputs */

const ja_calendar_heading_label = /** @type {(inputs: Calendar_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Watch Now`)
};

const en_calendar_heading_label = /** @type {(inputs: Calendar_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Watch Now`)
};

/**
* | output |
* | --- |
* | "Watch Now" |
*
* @param {Calendar_Heading_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_heading_label = /** @type {((inputs?: Calendar_Heading_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Heading_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_calendar_heading_label(inputs)
	return en_calendar_heading_label(inputs)
});